/**
 * Component: Search bar
 * ------------------------------------------------------------------------------
 * Script to control the appearance and functionality of all search bar components.
 *
 * @namespace searchBar
 */
import cssClasses from '~/helpers/cssClasses';
import {getSiblings, on} from '~/helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  overlay: '[js-search="overlay"]',
  form: '[js-search-bar="form"]',
  input: '[js-search-bar="input"]',
  label: '[js-search-bar="label"]',
  submit: '[js-search-bar="submit"]',
  fixedContent: '[js-search-bar="fixed-content"]',
};

/**
 * Create a new search bar object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    overlay: document.querySelector(selectors.overlay),
    form: [...document.querySelectorAll(selectors.form)],
    input: [...document.querySelectorAll(selectors.input)],
    fixedContent: document.querySelector(selectors.fixedContent),
  };

  /**
   * Instance defaults.
   */
  const placeholder = document.querySelector(selectors.label).innerText.trim();

  /**
   * Initialise component.
   */
  function init() {
    setEventListeners();
  }



  /**
   * Set keypress events on search input to hide label.
   * - Set focus events on search input to reset placeholder value.
   */
  function setEventListeners() {
    on('click', nodeSelectors.overlay, (event) => {
      const productItem = event.target.closest('.card-grid__item');

      if (productItem) {
        const title = productItem.querySelector('.product-card__title');
        const titleLabel = title.innerText.replace(/-/g, '_').replace(/\s/g, '_').toLowerCase();

        window.dataLayer.push({
          event: 'GAevent',
          eventID: '22',
          eventCategory: 'search',
          eventAction: 'suggest_result',
          eventLabel: titleLabel,
        });
      }
    });

    nodeSelectors.input.forEach((element) => {
      on('keyup', element, (event) => handleKeypressEvent(event));
    });

    nodeSelectors.input.forEach((element) => {
      on('blur', element, (event) => handleFocusEvent(event));
    });
  }


  /**
   * Handle search focus event.
   * @param {Event} event - blur event on search input.
   */
  function handleFocusEvent(event) {
    const target = event.target;

    if (target.value.length === 0) {
      getSiblings(target)[0].value = placeholder;
      getSiblings(target)[0].classList.remove(cssClasses.hidden);
    }
  }

  /**
   * Handle search keydown event.
   * @param {Event} event - keydown event on search input.
   */
  function handleKeypressEvent(event) {
    const target = event.target;
    getSiblings(target)[0].classList.remove(cssClasses.hidden);
    setTimeout(() => {
      if(target.value.length === 0) {
        nodeSelectors.fixedContent.classList.remove(cssClasses.hidden)
      } else {
        nodeSelectors.fixedContent.classList.add(cssClasses.hidden)
      }
    }, 200);
  }


  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};

